<button *ngIf="this.ready"
  color="#0083D8"
  border="#0083d8"
  class="button"
  (click)="delete()">
  <span class="btn-icon  icon-apagar"></span>
  Apagar Contrato
</button>
